export enum EmployeeDetailsTabs {
  GeneralTab = 0,
  TransactionTab = 1,
  StateHistoryTab = 2,
}
